/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-dd-pointer[_ngcontent-%COMP%]{cursor:pointer!important}.app-form-dropdown-fixed-scrollable[_ngcontent-%COMP%]{height:auto;max-height:200px;overflow-x:hidden}"];
export { styles as styles };
